import { WordArray, HmacSHA256 as CryptoJsHmacSHA256 } from 'crypto-js';
import { CryptoHelper } from './crypto-helper';

export function hmacSHA256(
  data: Uint8Array | string,
  key: Uint8Array | string,
) {
  const wordArray = CryptoHelper.sanitizeInput(data);
  const keyArray = CryptoHelper.sanitizeInput(key);
  const result: WordArray = CryptoJsHmacSHA256(wordArray, keyArray);
  return CryptoHelper.wordArrayToByteArray(result);
}
